export default __webpack_public_path__ + "static/media/0274.98cf9e64.jpg";